import { z } from 'zod'

export const projectCreateSchema = z.object({
	/** Parent client id — always the taxonomy's brand-level row. */
	clientId: z.uuid(),
	/**
	 * Optional operational sub-client (e.g. `msd-es` under `msd`). The service
	 * layer enforces that `subClientId.parentClientId === clientId` when both
	 * are set.
	 */
	subClientId: z.uuid().nullable().optional(),
	code: z.string().min(1),
	displayName: z.string().optional(),
	description: z.string().optional(),
	isActive: z.boolean().default(true),
	ownerEmail: z.email().optional(),
	pmEmail: z.email().optional(),
	validEnvs: z.array(z.string()).optional(),
})

export const projectUpdateSchema = projectCreateSchema.partial()

export type ProjectCreateInput = z.infer<typeof projectCreateSchema>
export type ProjectUpdateInput = z.infer<typeof projectUpdateSchema>
